import { CapoPlugin } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];